export const FAQs = [
  {
    question: "How much does Humming Homes cost?",
    answer:
      "Humming Homes is a monthly subscription service that starts at $250 per month. Your individual subscription cost will depend on the size of your home, as well as its location."
  },
  {
    question: "Where are you located?",
    answer:
      "Currently, Humming Homes operates in the Hamptons and Westchester County, NY, Fairfield County, CT, and South Florida. We're launching new markets soon!"
  },
  {
    question: "Who is responsible for my home?",
    answer:
      "Your Home Coordinator acts as a single point of contact for everything - think of them as the quarterback for your home. They are supported by 24/7 customer service and local in-market teams -- so no matter what might arise, the Humming Homes team is here to help you have more good days at home"
  },
  {
    question: "Who are the vendors you use?",
    answer:
      "We have a pre-vetted vendor network of over 3000 service providers. We only work with licensed vendors, who have to go through a rigorous vetting process."
  },
  {
    question: "What is your vendor vetting process?",
    answer:
      "We evaluate vendors rigorously — across multiple variables —  licensure, jobs completed, technical skill and more. "
  },
  {
    question: "How many projects can I have at once?",
    answer:
      "We recommend 3 ongoing projects at any given time. This will allow for quicker project completion, ongoing!"
  }
];
